import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Icon } from '@millionshow/client-libs';
import { rxResource } from '@angular/core/rxjs-interop';
import { EventDto, EventService } from '@millionshow/api-client';

@Component({
  selector: 'app-floating-buttons',
  standalone: true,
  imports: [CommonModule, RouterLink, Icon],
  templateUrl: './floating-buttons.component.html',
  styleUrls: ['./floating-buttons.component.css'],
})
export default class FloatingButtonsComponent {
  private readonly eventService = inject<EventService>(EventService);

  isMenuOpen = false;

  // 최신 ALLHOUSE 행사 1개 불러오기
  $latestEvent = rxResource({
    stream: () =>
      this.eventService.eventControllerSearchV1({
        pageNo: 1,
        pageSize: 1,
        type: 'ALLHOUSE' as EventDto['type'],
        orderBy: 'createdAt',
        align: 'desc',
      }),
  });

  event = computed(() => {
    const items = this.$latestEvent.value()?.items;
    return items && items.length > 0 ? items[0] : null;
  });

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }
}
